/* RESPONSIBLE TEAM: team-frontend-tech */
import relativeTime from 'embercom/lib/relative-time';

let bracketedRelativeTimeAgo = function (dateString) {
  return relativeTime(dateString, 'en-bracketed-relative-time-ago');
};

export default bracketedRelativeTimeAgo;
